import { Component, Vue } from 'vue-property-decorator'
import { FeedbackCreate } from '@/types/type'
import { feedbackCreate } from '@/api'
import { ElForm } from 'd-element-ui/types/form'
import Header from '@/components/componentWap/Header.vue'
@Component({
    name: 'feedback',
    components: {
        Header
    }
})
export default class extends Vue {
    $refs!: {
        validateForm: ElForm
    }
    private feedbackIng = true
    private timer = 2
    private setTimer: any = null
    private editData: FeedbackCreate = new FeedbackCreate()
    private submit() {
        this.$refs.validateForm.validate(async valid => {
            if (valid) {
                await feedbackCreate(this.editData)
                this.feedbackIng = false
                this.setTimer = setInterval(() => {
                    console.log('倒计时')
                    this.timer--
                    if (this.timer <= 0) {
                        this.$jump('/Question/QuestionContents')
                        this.timer = this.timer
                        clearInterval(this.setTimer)
                    }
                }, 1000)
            }
        })
    }
    beforeDestroy() {
        if (this.setTimer) {
            clearInterval(this.setTimer)
        }
    }
}